// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"9f346dc3","202":"7f3b6548","328":"4078a9e7","381":"7e5dbb2a","438":"b231a785","539":"9c3e2480","604":"62d2b0cd","757":"3c19ed12","845":"d16d6f40","873":"5a1b8568","920":"7b8dea19","960":"8f0a5ad0","976":"32c3abd2"}[chunkId] + ".chunk.js";
};